<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-budget'>{{ translations('navbar.budget_control') }}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-budget'>{{ translations('budget.archive_budget') }}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{ translations('budget.budget_details') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="d-flex flex-wrap">
        <div class="left-container">
          <h5 class="mb-3">Information</h5>
          <table class="table table-sm table-borderless table-information">
            <tbody>
              <tr>
                <th>{{ translations('budget.fiscal_year') }}</th>
                <td>{{budgetInfo.year}}</td>
              </tr>
              <tr>
                <th>{{ translations('budget.manager') }}</th>
                <td>{{budgetInfo.contacts_name}}</td>
              </tr>
              <tr>
                <th>{{ translations('budget.achievement_rate') }}</th>
                <td>{{budgetInfo.achievement}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="form-inline">
            <div class="form-group">
              <a class="btn btn-link btn-sm text-danger" href="#" @click="deleteBudget()">{{ translations('common.delete') }}</a>
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheckTax" ref="defaultCheckTax" v-model="taxIncluded" @change="toggleTax()">
              <label class="form-check-label" for="defaultCheckTax">{{ translations('common.tax_included') }}</label>
            </div>
          </div>
          <div class="table-scroll mb-4">
            <table class="table table-sm table-striped table-hover table-clickable table-800">
              <thead>
                <tr>
                  <th>{{ translations('budget.month') }}</th>
                  <th>{{ translations('budget.sales_budget') }}</th>
                  <th>{{ translations('budget.sales_performance') }}</th>
                  <th>{{ translations('budget.sales_achievement_rate') }}</th>
                  <th>{{ translations('budget.sales_compared_previous_period') }}</th>
                  <th>{{ translations('budget.gross_profit_budget') }}</th>
                  <th>{{ translations('budget.gross_profit_performance') }}</th>
                  <th>{{ translations('budget.gross_profit_achievement_rate') }}</th>
                  <th>{{ translations('budget.gross_profit_comparison_previous_period') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <tr>
                  <td>{{ translations('budget.annual') }}</td>
                  <td class="right">{{ toVatFormat(budgetDetails.annual.sales_budget) }}</td>
                  <td class="right">{{ toVatFormat(budgetDetails.annual.sales_result) }}</td>
                  <td class="right">{{ budgetDetails.annual.sales_achievement }}</td>
                  <td class="right">{{ budgetDetails.annual.sales_yoy }}</td>
                  <td class="right">{{ toVatFormat(budgetDetails.annual.gross_profilt_budget) }}</td>
                  <td class="right">{{ toVatFormat(budgetDetails.annual.gross_profit_result) }}</td>
                  <td>
                    <div class="d-flex align-items-center min-width-150">
                      <span class="table-percent-label">{{ budgetDetails.annual.gross_profit_achievement ? Number(budgetDetails.annual.gross_profit_achievement.replace("%", "").replace(",", "")).toLocaleString() + "%" : '' }}</span>
                      <div class="progress w-100"><div class="progress-bar progress-bar-striped bg-info" role="progressbar" :style="'width:' + calcGrossProfitAchivement(budgetDetails.annual.gross_profit_achievement) + ''" :aria-valuenow="calcGrossProfitAchivement(budgetDetails.annual.gross_profit_achievement)" aria-valuemin="0" aria-valuemax="100"></div></div>
                    </div>
                  </td>
                  <td class="right">{{ budgetDetails.annual.gross_profit_yoy }}</td>
                </tr>
                <template v-for="(budget, i) in budgetDetails.months">
                  <tr :key="i" data-toggle="modal" data-target="#SingleBudgetModal" @click="openEditModal(budget)">
                    <td>{{getMonthName(budget)}}</td>
                    <td class="right">{{ toVatFormat(budget.sales_budget) }}</td>
                    <td class="right">{{ toVatFormat(budget.sales_result) }}</td>
                    <td class="right">{{ budget.sales_achievement }}</td>
                    <td class="right">{{ (budget.sales_yoy && budget.sales_yoy !== "-") ? Number(budget.sales_yoy.replace("%", "").replace(",", "")).toLocaleString() + "%" : budget.sales_yoy }}</td>
                    <td class="right">{{ toVatFormat(budget.gross_profilt_budget) }}</td>
                    <td class="right">{{ toVatFormat(budget.gross_profit_result) }}</td>
                    <td>
                      <div class="d-flex align-items-center min-width-150">
                        <span class="table-percent-label">{{ budget.gross_profit_achievement }}</span>
                        <div class="progress w-100"><div class="progress-bar progress-bar-striped bg-info" role="progressbar" :style="'width:' + calcGrossProfitAchivement(budget.gross_profit_achievement) + ''" :aria-valuenow="calcGrossProfitAchivement(budget.gross_profit_achievement)" aria-valuemin="0" aria-valuemax="100"></div></div>
                      </div>
                    </td>
                    <td class="right">{{ (budget.gross_profit_yoy && budget.gross_profit_yoy !== "-") ? Number(budget.gross_profit_yoy.replace("%", "").replace(",", "")).toLocaleString() + "%" : budget.gross_profit_yoy }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <SingleBudgetModal :editMonthDetails="editMonthDetails" :clients="clients" :selectedMonth="selectedMonth" :vat="{taxIncluded:taxIncluded, vatRate:vatRate, toVatFormat:toVatFormat}"/><!-- VAT (toVatFormat) -->
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import SingleBudgetModal from '@/components/SingleBudgetModal'
import { mapState } from 'vuex'

export default {
  name: 'SinglueBudget',
  components: {
    VueElementLoading,
    SingleBudgetModal
  },
  props: {},
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      isLoading: false,
      budgetID: 0,
      budgetInfo: {},
      budgetDetails: {
        annual: {},
        months: []
      },
      editMonthDetails: [],
      clients: [],
      selectedMonth: 1,
      monthNames: [
        '', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
      ]
    }
  },
  created: async function () {
    this.isLoading = true
    this.getVatRate() // VAT

    if (this.$route.query.budget_id) {
      this.budgetID = this.$route.query.budget_id
    } else {
      this.$router.replace('archive-budget')
      return
    }
    await this.getBudget()
    await this.listClients()

    setTimeout(() => {
      this.isLoading = false
    }, 2000)
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getMonthName (budget) {
      if (budget.month === 0) {
        return this.translations('budget.annual')
      } else {
        if (this.currentLanguage === 'en') {
          const monthNumber = parseInt(budget.month, 10)
          return this.monthNames[monthNumber]
        } else {
          const monthNumber = parseInt(budget.month, 10)
          return monthNumber + this.translations('budget.month')
        }
      }
    },
    async getVatRate () { // VAT
      try {
        let result = await this.$http.post(this.$api_url.vat_rate)
        console.log(JSON.stringify(result.data))
        if (result.data.status === true) {
          this.vatRate = result.data.vat_rate
          this.restoreTax()
        } else {
          this.$toastr.error('消費税率が取得できませんでした。', 'エラー')
          this.taxIncluded = false
          this.$refs['defaultCheckTax'].disabled = true
        }
      } catch (error) {
        console.log('SingleBudget:getVatRate:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    restoreTax () { // VAT (rename *****)
      this.taxIncluded = this.$storage.get('SingleBudget.taxIncluded', this.taxIncluded) ? this.$storage.get('SingleBudget.taxIncluded', this.taxIncluded) : false
      console.log(this.taxIncluded)
    },
    toggleTax () { // VAT (rename *****)
      this.$storage.set('SingleBudget.taxIncluded', this.taxIncluded)
      console.log(this.taxIncluded)
    },
    toVatFormat (target, noData = null, taxIncluded = null, vatRate = null) { // VAT OUTPUT
      if (target) {
        taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
        vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
        let tax = Math.round(target * (100 + vatRate) / 100)
        if (!taxIncluded) {
          return `${Number(target).toLocaleString()} (${Number(tax).toLocaleString()})`
        } else {
          return `${Number(tax).toLocaleString()} (${Number(target).toLocaleString()})`
        }
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    noVatFormat (target, noData = null) { // VAT OUTPUT
      if (target) {
        return Number(target).toLocaleString()
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    filterTax (target, taxIncluded = null, vatRate = null) { // VAT INPUT
      target = target || 0
      taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
      vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
      if (!taxIncluded) {
        return target
      } else {
        let noTax = Math.round(target / ((100 + vatRate) / 100))
        return noTax
      }
    },

    async getBudget () {
      try {
        let budgets = await this.$http.post(
          this.$api_url.budgets_by_personnel,
          { budget_id: this.budgetID }
        )

        console.log('SingleBudget:getBudget:row_response', JSON.stringify(budgets))

        let $data = this.$invoiceTools.prepareResult(budgets.data, ['information', 'overview_details'], 'SingleBudget:getBudget')
        if ($data.success === true) {
          this.budgetInfo = $data.data.information
          this.budgetDetails = $data.data.overview_details
        } else {
          this.budgetInfo = {}
          this.budgetDetails = []
        }

        // this.loadTestData()

        console.log('SingleBudget:getBudget:budgetInfo', JSON.stringify(this.budgetInfo))
        console.log('SingleBudget:getBudget:budgetDetails', JSON.stringify(this.budgetDetails))
      } catch (error) {
        console.log('SingleBudget:getBudget:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    calcGrossProfitAchivement (value) {
      if (value === '-') {
        return '0%'
      }

      return value
    },

    async listClients () {
      try {
        let cList = await this.$http.post(this.$api_url.client_list)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'SinglePayments:listClients')
        if ($data.success === true) {
          this.clients = $data.data
        } else {
          this.clients = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        console.log('SinglePayments:listClients:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    deleteBudget () {
      this.$dialog.confirm('この予算を削除しますか?')
        .then(async () => {
          this.isLoading = true
          try {
            let del = await this.$http.post(this.$api_url.budget_delete, { budget_id: this.budgetID })

            let $data = this.$invoiceTools.prepareResult(del.data, '', 'SingleBudget:deleteBudget')

            if ($data.success === true) {
              this.$toastr.success('予算を削除しました', 'Success')
              this.$router.replace('archive-budget')
            } else {
              this.$toastr.error($data.data, 'エラー')
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SingleBudget:deleteBudget:catch(error): ', JSON.stringify(error))
            this.$toastr.error('予算削除にエラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    },

    openEditModal (budget) {
      this.editMonthDetails = budget.details
      this.selectedMonth = budget.month
    },

    // テストデータ
    loadTestData () {
      this.budgetInfo = {
        year: 2018,
        contacts_name: '山田太郎',
        achievement: '25%'
      }

      this.budgetDetails = {
        annual: this.loadSingleBudgetData('年間'),
        months: []
      }

      for (let i = 0; i < 12; i++) {
        this.budgetDetails.months.push(this.loadSingleBudgetData(i + 1))
        this.budgetDetails.months[i].details = []

        this.budgetDetails.months[i].details.push(this.loadSingleBudgetData(''))
        this.budgetDetails.months[i].details[0].id = 1
        this.budgetDetails.months[i].details[0].clients_id = 1
        this.budgetDetails.months[i].details[0].clients_name = '株式会社取引先1'

        this.budgetDetails.months[i].details.push(this.loadSingleBudgetData(''))
        this.budgetDetails.months[i].details[1].id = 2
        this.budgetDetails.months[i].details[1].clients_id = 2
        this.budgetDetails.months[i].details[1].clients_name = '株式会社取引先2'
      }
    },

    loadSingleBudgetData (month) {
      return {
        month: month,
        sales_budget: Math.floor(Math.random() * 1000000),
        sales_result: Math.floor(Math.random() * 100000),
        sales_achievement: Math.floor(Math.random() * 100),
        sales_yoy: Math.floor(Math.random() * 100),
        gross_profilt_budget: Math.floor(Math.random() * 1000000),
        gross_profit_result: Math.floor(Math.random() * 10000),
        gross_profit_achievement: Math.floor(Math.random() * 100),
        gross_profit_yoy: Math.floor(Math.random() * 100)
      }
    }
  }
}
</script>
